import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { april2026Data } from './april2026Data';
import { may2026Data } from './may2026Data';
import { june2026Data } from './june2026Data';

// Q2 2026 Standard Report - aggregates April, May, and June 2026
const allMonthlyReports = [
  april2026Data,
  may2026Data,
  june2026Data
];

const combinedData = combineReports(allMonthlyReports, 'Q2 2026 Standard Report');

export const q2_2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 4,
    year: 2026,
    quarter: 2,
    startMonth: 4,
    endMonth: 6
  }
};
